import { DocumentTypeEnum } from 'common/document/enums/document-type.enum';
import { labelsCandidateDocument } from 'common/document/ui/documents';

const documentLabel = {
  [DocumentTypeEnum.DRIVER_LICENSE]: 'Driver License',
  [DocumentTypeEnum.DOT_MEDICAL]: 'DOT Med Cert',
  [DocumentTypeEnum.DRIVER_CHECKLIST]: 'Driver Checklist',
  [DocumentTypeEnum.GENERIC]: 'Document',
  [DocumentTypeEnum.RETURN_TO_WORK]: 'Return to Work',
  [DocumentTypeEnum.MEDICAL_DISCONTINUANCE]: 'Medical Discontinuance Form',
  [DocumentTypeEnum.PHOTO_ID]: 'Photo ID',
};

export const documentTypeToLabel = (documentType: DocumentTypeEnum) =>
  documentLabel[documentType];

export const documentsToNameList = (documents: string[]) =>
  documents
    .map((d) => labelsCandidateDocument.get(d))
    .filter((s) => s)
    .join(', ');
